import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from "@angular/core";
import { TypeManagerDecorator } from "../../main/type.map.service";
import { AngBridge } from "../../util/ang.bridge.util";
import { S25AcademicGridsListComponent } from "./s25.academic.grids.list.component";
import { S25AcademicGridComponent } from "./s25.academic.grid.component";
import { AcademicGridsStore } from "./s25.academic.grids.store";

@TypeManagerDecorator("s25-ng-academic-grids-page")
@Component({
    selector: "s25-ng-academic-grids-page",
    template: `
        <h1>Academic Grids</h1>
        @if (!store.grid()) {
            <s25-ng-academic-grids-list />
        } @else {
            <s25-ng-academic-grid />
        }
    `,
    styles: ``,
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [S25AcademicGridsListComponent, S25AcademicGridComponent],
    providers: [AcademicGridsStore],
})
export class S25AcademicGridsPageComponent extends AngBridge {
    readonly store = inject(AcademicGridsStore);
}
